import React from 'react'
import {PuffLoader} from 'react-spinners'

const Spinners = () => {
    return (
        <div className='spinnerPage'>
            <PuffLoader
                color="#000000"
                size={80}
                speedMultiplier={2.3}
                cssOverride={
                    { borderWidth: "4px" }
                } />
        </div>
    )
}

export default Spinners